import { popoverAnatomy as parts } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system"

const { defineMultiStyleConfig, definePartsStyle } =
  createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  content: {
    fontSize: 14,
    boxShadow: "tooltip",
  },
  header: {
    fontWeight: 600,
  },
  body: {
    whiteSpace: "normal",
    pr: 8,
  },
  closeButton: {
    right: 1,
  },
})

/**
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/popover.ts}
 */
export const Popover = defineMultiStyleConfig({
  baseStyle,
})
